'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = exports.appComponent = {
    template: require('./app.html'),
    controllerAs: 'vm',
    controller: ["config", "authService", "categoryService", "sellerService", "$q", "localizer", "gettextCatalog", "reservationCampaignService", function controller(config, authService, categoryService, sellerService, $q, localizer, gettextCatalog, reservationCampaignService /*, $rootScope, $timeout, common*/) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.languageChanged = languageChanged;
        vm.getPolicyUrl = getPolicyUrl;
        vm.closeVaccinesAlert = closeVaccinesAlert;
        vm.cookieMessage = gettextCatalog.getString('Our website uses cookies to make your browsing experience better. By using our site, you agree to our use of cookies.');
        vm.cookieAcceptText = gettextCatalog.getString('Close and don\'t show again');
        vm.cookiePolicyText = gettextCatalog.getString('Learn more');
        vm.vaccinesAlertOpen = false;
        vm.isFebelcoCustomer = false;
        vm.navigationData = {};
        vm.isBeforeBlackFriday = isBeforeBlackFriday;
        vm.isBlackFridayDate = isBlackFridayDate;
        vm.checkVaccinDate = checkVaccinDate;

        vm.closeReservationCampaignAlert = closeReservationCampaignAlert;
        vm.activeCampaigns = [];

        function init() {
            var _this = this;

            var tenants = authService.customUserInfo.tenants;
            vm.activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.isFebelcoCustomer = authService.isFebelcoCustomer;
            localizer.addLanguageChangeEvent(function () {
                return _this.languageChanged();
            });
            vm.vaccinesAlertOpen = getVaccinesAlertOpenFromLocalStorage();
            if (vm.isFebelcoCustomer) {
                reservationCampaignService.getActiveReservationCampaigns().then(function (response) {
                    response.forEach(function (campaign) {
                        campaign.alertDismissed = getReservationCampaignAlertDismissedFromLocalStorage(campaign.code);
                    });
                    vm.activeCampaigns = response;
                });
            }
        }

        function getVaccinesAlertOpenFromLocalStorage() {
            if (window.localStorage.getItem('vaccinesAlertOpen2020') === 'false') {
                return false;
            } else {
                return true;
            }
        }

        function getReservationCampaignAlertDismissedFromLocalStorage(code) {
            if (window.localStorage.getItem('ReservationCampaignAlertOpen' + code) === 'false') {
                return true;
            } else {
                return false;
            }
        }

        function closeReservationCampaignAlert(campaign) {
            campaign.alertDismissed = true;
            window.localStorage.setItem('ReservationCampaignAlertOpen' + campaign.code, false);
        }

        function languageChanged() {
            categoryService.getMenuCategories().then(function (result) {
                vm.navigationData.categories = result;
            });
        }

        function getPolicyUrl() {
            switch (window.localStorage.getItem('language')) {
                case 'nl':
                    return 'http://www.profficina.be/nl/algemene-voorwaarden.html';
                case 'fr':
                    return 'http://www.profficina.be/fr/conditions-generales.html';
                default:
                    return 'http://www.profficina.be/nl/algemene-voorwaarden.html';
            }
        }

        function closeVaccinesAlert() {
            vm.vaccinesAlertOpen = false;
            window.localStorage.setItem('vaccinesAlertOpen2020', false);
        }

        function isBlackFridayDate() {
            if ((0, _moment2.default)('2019-11-29').format('YYYY-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD')) {
                return true;
            }
            return false; //change to false to make this work
        }

        function isBeforeBlackFriday() {
            if ((0, _moment2.default)('2019-11-29').format('YYYY-MM-DD') > (0, _moment2.default)().format('YYYY-MM-DD')) {
                return true;
            }
            return false;
        }

        function checkVaccinDate() {
            var fluVaccinesEndDate = config.fluVaccines.endDate;
            var fluVaccinesStartDate = config.fluVaccines.startDate;
            return (0, _moment2.default)(fluVaccinesStartDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(fluVaccinesEndDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD');
            // var today= moment().format('YYYY-MM-DD');
            // var startDate= moment('2020-03-16').format('YYYY-MM-DD');
            // var endDate = moment('2020-04-15').format('YYYY-MM-DD');
            // var condition = startDate <= today && endDate >= today;
            // if (condition) {
            //     return true;
            // }
            // return false; //change to false to make this work
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./app.component.js
// module id = 255
// module chunks = 0